module.exports = __webpack_public_path__ + "media/porsche-design-system.d29d9376.mp4";